// Flip to true to show the Pro/Premium plan cards and upgrade links again.
export const SHOW_PAID_PLANS = false;
